import { render, staticRenderFns } from "./UnbindErpBox.vue?vue&type=template&id=36f46122&scoped=true"
import script from "./UnbindErpBox.vue?vue&type=script&lang=js"
export * from "./UnbindErpBox.vue?vue&type=script&lang=js"
import style0 from "./UnbindErpBox.vue?vue&type=style&index=0&id=36f46122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f46122",
  null
  
)

export default component.exports